<template>
  <GestionEventos />
</template>
<script>
import GestionEventos from "./components/GestionEventos.vue";
export default {
  name: "Evento",
  components: { GestionEventos }
};
</script>